module.exports = __webpack_public_path__ + "static/media/total-team-icon.8599de50.svg";